import { Injectable } from '@angular/core';
import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Store } from '@ngrx/store';
import { LocationListLocalStoreService } from '../../location-list-local-store.service';
import { Observable, switchMap } from 'rxjs';
import { selectAddressTranslationsDictionary, selectIsLocationFieldBlacklisted } from '../../state/location-list-selectors';
import { LSCField } from '../../../../../models/LSCFields';
import { ICellRendererParams } from 'ag-grid-community';
import { Location } from '../../../../../models/locations-models/location';
import { TRANSLATABLE_FIELDS } from '../../../constants';

interface SimpleTextCellState extends AgCellState {}

@Injectable()
export class SimpleTextCellLocalStoreService extends AgCellLocalStoreService<SimpleTextCellState> {

  constructor(private store: Store, private locationGridStore: LocationListLocalStoreService) {
    super({
      cellValue: '',
      params: null
    })
  }

  readonly viewModel$: Observable<{
    value: string,
    valueLoading: boolean,
    isFieldBlacklisted: boolean,
    isFieldTranslatable: boolean
    translationShown: boolean,
    translationLoading: boolean, }> = this.params$.pipe(
        switchMap((params: ICellRendererParams<Location>) =>
            this.select(this.store.select(selectIsLocationFieldBlacklisted(params?.data?.id, (params?.colDef?.field) as LSCField)),
                this.locationGridStore.loadingValues$,
                this.locationGridStore.loadingTranslations$,
                this.locationGridStore.showTranslations$,
                this.store.select(selectAddressTranslationsDictionary),
                (isFieldBlacklisted,
                 loadingValues,
                 loadingTranslations,
                 showTranslations,
                 translationsDictionary) => {
              const translationShown = showTranslations[params?.data?.id];
              const isFieldTranslatable= (TRANSLATABLE_FIELDS as string[]).includes(params?.colDef?.field);
              return {
                value: translationShown && isFieldTranslatable ?
                    translationsDictionary[params?.data?.id]?.[params?.colDef?.field] : params.value,
                valueLoading: loadingValues[params?.data?.id]?.[params?.colDef?.field],
                isFieldBlacklisted,
                isFieldTranslatable,
                translationShown,
                translationLoading: loadingTranslations[params?.data?.id],
              }
            })
        )
    );

}


